import React, { useState } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { UnloadingSvg } from "../../../svgFiles/UnloadingSvg";
import TimeIcon from "../../../images/time.svg";
import MangoIcon from "../../../images/mango.svg";
import KgsIcon from "../../../images/kgs.svg";
import boxesIcon from "../../../images/boxes.svg";
import DateIcon from "../../../images/calendar.svg";
import RejectedIcon from "../../../images/rejected.svg";
import KgCaseIcon from "../../../images/kgCase.svg";
import CaseIcon from "../../../images/case.svg";
import { formatDateAndTimeFromUTC } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { capitalizeFirstLetter } from "../../../helpers/Utils";
const OverViewModal = ({ show, setShow, record, mode }) => {
  console.log({ record });
  const { _t } = useTranslator();
  const handleClose = () => {
    setShow(false);
  };
  const [formData, setFormData] = useState(record);
  const {
    batch_code,
    supplier_name,
    created_at,
    fruit_name,
    total_entered_kg,
    total_selected_kg,
    selected_cheeks_kg,
    selected_stripe_kg,
    rejected_kg,
    rejected_strips_kg,
    rejected_cheeks_kg,
    rejected_pieces_kg,
    pending_kg,
    status,
    packing_and_sorting,
    packed_percentage
  } = formData;

  // Extract packing_and_sorting fields
  const packingData = packing_and_sorting || {};
  const {
    cheeks_prime_10lb_box,
    cheeks_prime_20lb_box,
    cheeks_seconds_20lb_box,
    strips_prime_10lb_box,
    strips_prime_20lb_box,
    strips_seconds_20lb_box,
    pieces_20lb_box,
    total_pallet_ready,
  } = packingData;
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("adding_washing_data", "Adding Washing Data")}
      headerInfo="true"
      headername={supplier_name}
      BatchCode={batch_code}
    >
      <div className="modalScroll">
      <h4 className="overViewtitle">{UnloadingSvg} {_t('brokerage_data', 'Brokerage Data')}</h4>
      <ul className="overviewGrid processing mb-4">
        <li className="overviewGrid_card">
          {" "}
          <img src={DateIcon} alt="" />
          {_t('date', 'Date')} : <span>{formatDateAndTimeFromUTC(created_at).date}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={TimeIcon} alt="" />
          {_t('time', 'Time')} : <span>{formatDateAndTimeFromUTC(created_at).time}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={MangoIcon} alt="" />
          {_t('fruit_type', 'Fruit Type')} : <span>{fruit_name}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={MangoIcon} alt="" />
          {_t('fruit_type_variety', 'Fruit Type Variety')}:{" "}
          <span>{capitalizeFirstLetter(record?.fruit_type_variety)}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={KgsIcon} alt="" />
          {_t('kg_entered', 'KG Entered')} : <span>{total_entered_kg}</span>
        </li>
        {/* <li className="overviewGrid_card">
          {" "}
          <img src={KgCaseIcon} alt="" />
          KG Sorted : <span>{total_selected_kg}</span>
        </li> */}
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t('prime_total_kg', 'Prime Total KG')} : <span>{record?.prime_total_kg}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t('seconds_total_kg', 'Seconds Total KG')} : <span>{record?.seconds_total_kg}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t('pieces_total_kg', 'Pieces Total KG')} : <span>{record?.pieces_total_kg}</span>
        </li>
        {/* <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          Selected Cheeks KG : <span>{selected_cheeks_kg}</span>
        </li> */}
        {/* <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          Selected Strips KG : <span>{selected_stripe_kg}</span>
        </li> */}
        {/* <li className="overviewGrid_card">
          {" "}
          <img src={RejectedIcon} alt="" />
          Rejected KG : <span>{rejected_kg}</span>
        </li> */}

        <li className="overviewGrid_card">
          {" "}
          <img src={RejectedIcon} alt="" />
          {_t('rejected_strips_kg', 'Rejected Strips KG')} : <span>{rejected_strips_kg || 0}</span>
        </li>

        <li className="overviewGrid_card">
          {" "}
          <img src={RejectedIcon} alt="" />
          {_t('rejected_cheeks_kg', 'Rejected Cheeks KG')} : <span>{rejected_cheeks_kg || 0}</span>
        </li>

        <li className="overviewGrid_card">
          {" "}
          <img src={RejectedIcon} alt="" />
          {_t('rejected_pieces_kg', 'Rejected Pieces KG')} : <span>{rejected_pieces_kg || 0}</span>
        </li>

        <li className="overviewGrid_card">
          {" "}
          <img src={KgsIcon} alt="" />
          {_t('pending_kg', 'Pending KG')} : <span>{pending_kg || 0}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t('total_packed_percentage', 'Total Packed (%)')} : <span>{packed_percentage || 0}</span>
        </li>
        {record?.fruit_type_variety === "pasting" && (
          <li className="overviewGrid_card">
            {" "}
            <img src={CaseIcon} alt="" />
            {_t('status', 'Status')} : <span>{record?.status ? capitalizeFirstLetter(record.status) : "—"}</span>
          </li>
        )}
      </ul>

      {packing_and_sorting && (
        <>
          <h4 className="overViewtitle mt-4">{UnloadingSvg} {_t('packing_sorting_data', 'Packing & Sorting Data')}</h4>
          <ul className="overviewGrid processing mb-4">
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('cheeks_prime_10lb_box', 'Cheeks Prime 10lb Box')} : <span>{cheeks_prime_10lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('cheeks_prime_20lb_box', 'Cheeks Prime 20lb Box')} : <span>{cheeks_prime_20lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('cheeks_seconds_20lb_box', 'Cheeks Seconds 20lb Box')} : <span>{cheeks_seconds_20lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('strips_prime_10lb_box', 'Strips Prime 10lb Box')} : <span>{strips_prime_10lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('strips_prime_20lb_box', 'Strips Prime 20lb Box')} : <span>{strips_prime_20lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('strips_seconds_20lb_box', 'Strips Seconds 20lb Box')} : <span>{strips_seconds_20lb_box || 0}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={CaseIcon} alt="" />
              {_t('pieces_20lb_box', 'Pieces 20lb Box')} : <span>{pieces_20lb_box || 0}</span>
            </li>
            {/* <li className="overviewGrid_card">
              {" "}
              <img src={KgCaseIcon} alt="" />
              Total Pallet Ready : <span>{total_pallet_ready || 0}</span>
            </li> */}
          </ul>
          
        </>
      )}
      </div>
    </CommonModal>
  );
};

export default OverViewModal;
